import styled from 'styled-components';
import { AllieDefaultColors } from '../../../common/color.types';
import { AllieButton, AllieButtonCorner, AllieButtonSize } from '../Button';

const padding = {
  normal: 16,
  medium: 14,
  small: 12,
  xs: 8,
  none: 0,
};

interface AllieIconButtonParams {
  corner: AllieButtonCorner;
  allieSize: AllieButtonSize;
  allieColor: AllieDefaultColors;
}

export const StyledIconButton = styled(AllieButton)<AllieIconButtonParams>`
  && {
    --border-radius: ${(props: AllieIconButtonParams) =>
      props.corner === 'rounded' ? '138' : '10'}px;
  }
  && {
    --padding-top: ${(props: AllieIconButtonParams) => padding[props.allieSize]}px;
  }
  && {
    --padding-bottom: ${(props: AllieIconButtonParams) => padding[props.allieSize]}px;
  }
  && {
    --padding-start: ${(props: AllieIconButtonParams) => padding[props.allieSize]}px;
  }
  && {
    --padding-end: ${(props: AllieIconButtonParams) => padding[props.allieSize]}px;
  }
  && {
    --border-color: var(--allie-color-light-60);
  }
  && {
    --border-style: solid;
  }
  && {
    --border-width: 1px;
  }
  && {
    --box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  }
`;
